import React, { useState, useEffect } from "react";
import { apiJson, apiBlob } from "../../utils/api";

const PaymentPage = () => {
  const [loading, setLoading] = useState(true);
  const [feeBreakdown, setFeeBreakdown] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [payment, setPayment] = useState(null);
  const [receipt, setReceipt] = useState(null);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const data = await apiJson("/api/student/admission/payment");
      setFeeBreakdown(data.feeBreakdown || []);
      setTotalAmount(data.totalAmount || 0);
      setPayment(data.payment || null);
      setReceipt(data.receipt || null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePay = async () => {
    setError("");
    setMessage("");
    try {
      const data = await apiJson("/api/student/admission/payment", {
        method: "POST",
        body: JSON.stringify({ paymentMode: "ONLINE" }),
      });
      setMessage("Payment successful!");
      fetchData();
    } catch (err) {
      setError(err.message);
    }
  };

  const downloadReceipt = async (receiptId) => {
    try {
      const blob = await apiBlob(`/api/student/admission/receipt/${receiptId}`);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `receipt_${receiptId}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setError("Error downloading receipt");
    }
  };

  if (loading) return <p className="text-gray-500">Loading...</p>;

  return (
    <div className="max-w-2xl mx-auto">
      <h1 className="text-xl font-bold text-gray-800 mb-4">Payment</h1>

      {message && <div className="bg-green-50 text-green-700 p-3 rounded mb-4 text-sm">{message}</div>}
      {error && <div className="bg-red-50 text-red-600 p-3 rounded mb-4 text-sm">{error}</div>}

      {/* Fee Breakdown */}
      <div className="bg-white rounded shadow mb-4">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b">
            <tr>
              <th className="text-left px-4 py-2">Fee Head</th>
              <th className="text-right px-4 py-2">Amount</th>
            </tr>
          </thead>
          <tbody>
            {feeBreakdown.length === 0 ? (
              <tr>
                <td colSpan={2} className="px-4 py-3 text-center text-gray-400">
                  No fees configured for your admission
                </td>
              </tr>
            ) : (
              <>
                {feeBreakdown.map((item, idx) => (
                  <tr key={idx} className="border-b">
                    <td className="px-4 py-2">{item.name}</td>
                    <td className="px-4 py-2 text-right">{parseFloat(item.amount).toFixed(2)}</td>
                  </tr>
                ))}
                <tr className="font-semibold bg-gray-50">
                  <td className="px-4 py-2">Total</td>
                  <td className="px-4 py-2 text-right">{parseFloat(totalAmount).toFixed(2)}</td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>

      {/* Payment Status / Action */}
      {payment && payment.paymentStatus === "SUCCESS" ? (
        <div className="bg-green-50 p-4 rounded shadow">
          <p className="text-green-700 font-semibold">Payment Completed</p>
          <p className="text-sm text-gray-600 mt-1">
            Transaction ID: {payment.transactionId || "N/A"} |
            Mode: {payment.paymentMode} |
            Paid: {payment.paidAt ? new Date(payment.paidAt).toLocaleDateString("en-IN") : "-"}
          </p>
          {receipt && (
            <button
              onClick={() => downloadReceipt(receipt.id)}
              className="mt-3 bg-indigo-600 text-white px-4 py-1.5 rounded text-sm hover:bg-indigo-700"
            >
              Download Receipt
            </button>
          )}
        </div>
      ) : feeBreakdown.length > 0 ? (
        <button
          onClick={handlePay}
          className="bg-indigo-600 text-white px-6 py-2 rounded hover:bg-indigo-700 transition"
        >
          Pay Now
        </button>
      ) : null}
    </div>
  );
};

export default PaymentPage;
